import * as React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Icon from './Icons';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem } from 'reactstrap';

import createLogger from '../../utils/createLogger';

const DEBUG = true;
const debug = createLogger(DEBUG, `static/Elements.js`);

/** -------- Button -------- */
class Button extends React.Component {

  static propTypes = {
    hover: PropTypes.bool,
    active: PropTypes.bool,
    onClick: PropTypes.func,
    children: PropTypes.node,
    disabled: PropTypes.bool,
    primary: PropTypes.bool,
    action: PropTypes.bool,
    lowkey: PropTypes.bool,
    navitem: PropTypes.bool,
    small: PropTypes.bool,
    type: PropTypes.string,
    text: PropTypes.bool,
    icon: PropTypes.string,
    large: PropTypes.bool,
    danger: PropTypes.bool,
    selected: PropTypes.bool,
  };

  render() {
    let {
      hover,
      active,
      onClick,
      disabled,
      primary,
      action,
      lowkey,
      navitem,
      small,
      type,
      text,
      icon,
      large,
      danger,
      selected,
      ...props,
    } = this.props;
    const children = React.Children.toArray(this.props.children);

    const config = {
      onClick,
      disabled, ...props,
      className: classnames({
        icon: !!icon,
        small, large,
        active, hover,
        action, danger,
        [type]: !!type,
        primary,
        lowkey,
        text,
        navitem,
        selected,
      }),
    };

    if (type === `submit`) {
      config.type = `submit`;
    }

    let content;
    switch (icon) {
      case `search`: content = <Icon.Search/>; break;
      case `close`:  content = <Icon.Close/> ; break;
      case `trash`:  content = <Icon.Trash/> ; break;
      case `refresh`: content = <Icon.Refresh/>; break;
      default:       content = children;
    }

    // if there are two children, probably icon + text
    if (content.length > 1) {
      if (typeof content[0] === `string`) {
        content[0] = <span key={0}>{ content[0] }</span>;
        content[1] = React.cloneElement(content[1], {key: 1});
      }

      if (typeof content[1] === `string`) {
        content[0] = React.cloneElement(content[0], {key: 0});
        content[1] = <span key={1}>{ content[1] }</span>;
      }
    }

    return (
      <button {...config}>
        { content }
      </button>
    )
  }
}


class Toolbar extends React.Component {

  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  render() {
    const { children } = this.props;
    return (
      <div className="toolbar">
        { children }
      </div>
    )
  }
}


class CustomNav extends React.Component {

  static propTypes = {
    children: PropTypes.node.isRequired,
    collapse: PropTypes.bool,
  };

  render() {
    const {children} = this.props;
    return (
      <Navbar>
        {children}
      </Navbar>
    )
  }
}

export {
  Toolbar,
  Button,
  Nav,
}



// WEBPACK FOOTER //
// ./src/components/static/Elements.js